<template>
  <div class="rounded-[30px] bg-white py-3 pl-3 flex">
    <div
      style="
        background-image: url('/assets/images/dialog/login/login-left.webp');
        background-size: cover;
        background-repeat: no-repeat;
        width: 320px;
        height: 516px;
      "
      class="flex flex-col items-center justify-center rounded-[20px]"
    >
      <img
        class="mb-2"
        src="@/assets/images/logo-icon.png"
        width="64"
        height="64"
        alt="logo"
      />
      <img
        class=""
        src="@/assets/images/logo-text.png"
        alt="white logo"
        height="21"
        width="125"
      />
    </div>
    <div class="px-14 relative flex flex-col h-[516px]">
      <p v-if="props.title" class="Roboto-Bold-24 text-black pt-3">
        {{ props.title }}
      </p>
      <div v-if="props.third" class="mb-4">
        <div class="flex items-center gap-x-4 mt-8 mb-6">
          <div class=" rounded-full border border-gray-line cursor-pointer h-11 px-3 flex items-center gap-1 hover:bg-[#F7F7F8]" @click="loginByGoogle">
            <img
            :src="googleIcon"
            alt="google"
            height="20"
            width="20"
          />
          <span class="text-text-deep Roboto-12">{{ $t('login-by-google') }}</span>
          </div>
          <div class=" rounded-full border border-gray-line cursor-pointer flex items-center justify-center h-11 w-11 hover:bg-[#F7F7F8]" @click="loginFacebook">
            <img
            :src="facebookIcon"
            alt="facebook"
            height="20"
            width="20"
          />
          </div>
          <div class=" rounded-full border border-gray-line cursor-pointer flex items-center justify-center h-11 w-11 hover:bg-[#F7F7F8]" @click="loginByApple">
            <img
            :src="appleIcon"
            alt="apple"
            height="20"
            width="20"
          />
          </div>
        </div>
        <div class="w-full h-4 flex items-center">
          <div class="flex-1 h-px bg-gray-line"></div>
          <div class="px-4">{{ $t("or") }}</div>
          <div class="flex-1 h-px bg-gray-line"></div>
        </div>
      </div>
      <div class="flex-1">
        <slot></slot>
      </div>
      <!-- <slot name="footer"></slot> --> 
      <div class="w-[336px] text-center mb-3">
        <p class="Roboto-12 text-text-gray">
          <span>{{ $t("login-agree1") }}</span>
          &nbsp;<a :href="termsofService" target="_blank" class="underline text-text-deep">{{
            $t("login-agree2")
          }}</a
          >&nbsp;
          <span>{{ $t("login-agree3") }}</span>
          &nbsp;<a :href="privacyPolicy" target="_blank" class="underline text-text-deep">{{
            $t("login-agree4")
          }}</a>
          <span>{{ $t("login-agree5") }}</span>
        </p>
      </div>

      <div
        class="absolute top-1 right-4 flex items-center justify-center rounded-full w-8 h-8 cursor-pointer"
        @click="onClose"
      >
        <NuxtImg
          src="/assets/images/dialog/login/close.svg"
          :alt="$t('AI_Enhance')"
          width="16"
          height="16"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import messageBox from "@/composables/messageBox";
import { useMainStore } from "@/store/index";
import { termsofService, privacyPolicy } from "@/utils/config";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider,
  FacebookAuthProvider,
  browserPopupRedirectResolver,
} from "firebase/auth";
const { $firebaseApp,$encryptor } = useNuxtApp();
const mainStore = useMainStore();
const localePath = useLocalePath();
const LoginType = {
  apple: "apple",
  google: "google",
  facebook: "facebook",
};
const router = useRouter()
const route = useRoute()
const fullLoading = useFullLoading();
const googleIcon =
  "data:image/png;base64,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";
const appleIcon =
  "data:image/png;base64,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";
const facebookIcon =
  "data:image/png;base64,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";

const { t } = useI18n();
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  third: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(["close"]);
function onClose() {
  emit("close");
}
function loginByGoogle() {
  console.log("Google login");
  useLogEvent({
    eventName: "login",
    eventParams: { method: "Google" },
    needPrefix: false,
  });
  fullLoading.show(t("login-loading"));
  const provider = new GoogleAuthProvider();
  provider.addScope("https://www.googleapis.com/auth/userinfo.email");
  provider.addScope("https://www.googleapis.com/auth/userinfo.profile");
  const auth = getAuth($firebaseApp);
  signInWithPopup(auth, provider, browserPopupRedirectResolver)
    .then((result) => {
      const idToken = result._tokenResponse.idToken;
      login(LoginType.google, idToken);
    })
    .catch((error) => {
      const errorCode = error.code;
      console.log("error", error);
      errorCodeMsg(errorCode, LoginType.google);
    });
}
function loginByApple() {
  console.log("apple login");
  useLogEvent({
    eventName: "login",
    eventParams: { method: "Apple" },
    needPrefix: false,
  });

  fullLoading.show(t("login-loading"));

  const provider = new OAuthProvider("apple.com");
  provider.addScope("email");
  provider.addScope("name");
  const auth = getAuth($firebaseApp);
  signInWithPopup(auth, provider, browserPopupRedirectResolver)
    .then((result) => {
      // The signed-in user info.
      const user = result.user;

      login(LoginType.apple, user.accessToken);
      // ...
    })
    .catch((error) => {
      console.log("error:", error);
      try {
        const errorCode = error.code;
        errorCodeMsg(errorCode, LoginType.apple);
      } catch (e) {}
      // Handle Errors here.

      // ...
    });
  // }
}
function loginFacebook() {
  console.log("Facebook login");
  useLogEvent({
    eventName: "login",
    eventParams: { method: "Facebook" },
    needPrefix: false,
  });

  fullLoading.show(t("login-loading"));

  var provider = new FacebookAuthProvider();
  provider.addScope("email");
  provider.addScope("public_profile");
  const auth = getAuth($firebaseApp);

  signInWithPopup(auth, provider, browserPopupRedirectResolver)
    .then((result) => {
      // The signed-in user info.
      var user = result.user;

      // This gives you a Facebook Access Token. You can use it to access the Facebook API.
      var accessToken = user.accessToken;
      console.log("user result", result);
      login(LoginType.facebook, accessToken);
      // ...
    })
    .catch((error) => {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      // var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      // var credential = error.credential;
      console.log("errorCode", errorCode);
      console.log("message", errorMessage);
      console.log("credential", error.credential);
      if (errorCode === "auth/account-exists-with-different-credential") {
        console.log(1211);
        errorCodeMsg(errorCode, LoginType.facebook);
      } else {
        errorCodeMsg(errorCode, LoginType.facebook);
      }
      // ...
    });
  // }
}
// function loginEmail() {
//   mainStore.setVisibleLogin(false);
//   mainStore.setVisibleEmailLogin(true);
// }
function errorCodeMsg(errorCode: string, platform: string) {
  useLogEvent({
    eventName: "login-catch",
    eventParams: { platform, errorCode },
  });

  switch (errorCode) {
    case "auth/network-request-failed":
    case "auth/internal-error":
      messageBox.error(t("login"), t("network-err-try"));

      break;
    case "auth/account-exists-with-different-credential":
      messageBox.error(t("login"), t("different-auth"));

      break;
    case "auth/popup-closed-by-user":
      // messageBox.error(
      //   t("header-login"),
      //   t("different-auth")
      // );
      break;
    case "auth/popup-blocked":
      console.log("重定向登录");
      messageBox.error(t("login"), t("login-blocked-err"));
      break;
    default:
      messageBox.error(t("login"), t("login-err"));

      break;
  }
  fullLoading.hide();
}
function login(type, token) {
  useApi
    .login({ idTokenString: token })
    .then((res) => {
      const { data, code } = res;

      if (code === 0) {
        if(data.register === 1){
          useLogEvent({ eventName: "sign-up",fbEvent: false });
          useFBLogEvent({ eventName: "CompleteRegistration",needPrefix: false });
        }else {
          useLogEvent({ eventName: "login-success", eventParams: { type } });
        }
        localStorage.setItem("token", data.token);
        localStorage.setItem("userInfo", JSON.stringify(data.user));
        mainStore.setUserInfo(data.user);
        // messageBox.success(t("login-success"));
        messageBox.success(t("login"), t("login-success"));
        // const visitorLoginEvent = new CustomEvent("visitorLoginEvent", {
        //   detail: data.user,
        // });
        // window.dispatchEvent(visitorLoginEvent);
        mainStore.setVisibleLogin(false);
        mainStore.setVisibleSignUp(false);
        //如果会员页过来登录的，登录完，非会员返回会员页
        if (mainStore.vipToLogin && data.user.memberType == 0) {
          mainStore.setVisibleVipDialog(true);
        }
        fullLoading.hide();
        mainStore.setVipToLogin(false);
        // 更新周剩余次数
        useApi.getWeekCount().then((res) => {
          if (res.code == 0) {
            mainStore.setWeekCount(res.data ?? 0);
          }
        });
        if (route.path.includes("/picma_web/enhance/")) {
          return;
        }
        router.push(localePath({ name: "master_center" }));
      }
    })
    .catch((e) => {
      console.log("登录异常:", e);
      fullLoading.hide();
      useLogEvent({ eventName: "login-fail", eventParams: { type } });
      messageBox.error(t("login"), t("login-err"));
    });
}
</script>
<style lang="scss" scoped></style>
